import Subject from "../cse4sub/Subject";
import React from 'react'
import cm from '../assets/CSE304mid21.pdf'
import ce from '../assets/CSE304end21.pdf'

export default function Mp() {
  return (
    <div>
       <Subject title="Microprocessor(CSE304)" mid="Q. Paper"
    book1="R. Gaonkar, “Microprocessor Architecture, Programming and Applications with the 8085”" 
    book2="B.Ram, Fundamentals of Microprocessors and Microcontrollers "
    book1Link="https://www.pdfdrive.com/download.pdf?id=176171206&h=297e7d12b2b64441cd929082982020db&u=cache&ext=pdf
    "
     book2Link="https://www.kngac.ac.in/elearning-portal/ec/admin/contents/2_18KP3PELP4_2020101606330929.pdf
     "
      int21="#" mid21={cm} end21={ce}
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}